import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import moment from 'moment';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';

import { Content } from 'api';
import { DatePickers } from 'components';

import { usePostContext } from '../../PostContext';
import { Switch } from '../';
import Widget from './WidgetContainer';

const ScheduleExpirePost: FC = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<Content>();
  const { state, dispatch } = usePostContext();

  const { schedule } = values;
  const { publish, expire } = schedule;

  const minExpireDate = getMinExpiresDate();

  function onChangeSwitch() {
    if (state.schedule) {
      setFieldValue('schedule.publish', null);
      setFieldValue('schedule.expire', null);
    }

    dispatch({ type: 'schedule' });
  }

  function onChangeDate(type: string, time: number) {
    if (type === 'publish' && expire) {
      const publishMoment = moment.unix(time);
      const expireMoment = moment.unix(expire);
      const exceedsExpiration = publishMoment.isAfter(expireMoment);

      if (exceedsExpiration) {
        setFieldValue('schedule.expire', null);
      }
    } else if (type === 'expire' && publish) {
      const publishMoment = moment.unix(publish);
      const expireMoment = moment.unix(time);
      const exceedsExpiration = publishMoment.isAfter(expireMoment);

      if (exceedsExpiration) {
        time = null;
      }
    }

    setFieldValue(`schedule[${type}]`, time);
  }

  function getMinExpiresDate() {
    return publish ? moment.unix(publish).format('YYYY-MM-DD') : 'today';
  }

  function renderBody() {
    return (
      <Grid container>
        <Grid item xs={1} />
        <Grid item xs={10} container wrap="nowrap" spacing={2}>
          <Grid item xs={6}>
            <DatePickers.Select
              enableTime
              label={t('sharing:scheduled')}
              value={publish}
              setValue={time => onChangeDate('publish', time)}
              fullWidth
              minDate="today"
              defaultValue={t('posting:selectTime')}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickers.Select
              enableTime
              label={t('posting:expire')}
              value={expire}
              setValue={time => onChangeDate('expire', time)}
              fullWidth
              minDate={minExpireDate}
              defaultValue={t('posting:never')}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid item xs>
      <Widget
        titleKey="posting:scheduleExpire"
        subtitleKey="posting:guidelineScheduleExpire"
        icon={<QueryBuilderIcon color={state.schedule ? 'inherit' : 'disabled'} />}
        toggle={<Switch checked={state.schedule} onChange={onChangeSwitch} color="primary" />}>
        {state.schedule && renderBody()}
      </Widget>
    </Grid>
  );
};

export default ScheduleExpirePost;
